import PropTypes from "prop-types";

const VideoEmbed = ({ videoId }) => {
  return (
    <div className="col-lg-8">
      <iframe
        title="project-video"
        frameBorder="0"
        scrolling="no"
        style={{
          marginheight: "0",
          marginwidth: "0",
          width: "100%",
          height: "100%",
        }}
        type="text/html"
        src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0`}
      />
    </div>
  );
};

VideoEmbed.propTypes = {
  videoId: PropTypes.string.isRequired,
};

export default VideoEmbed;
